import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { isNullOrEmpty, showMessageToastCustom, translate } from '../../../utils/util';
import PhysicalConfirmationService from '../../../services/PhysicalConfirmationService';
import { BackButton, Button, Input, Title, Select } from '../../../components/UI/ComponentsUI';
import { onValueChange, validateInputsRequired } from '../../../utils/handleChangeHooks';
import { ENUMS } from '../../../utils/constants';

const PrintLabelIdentification = (props) => {
    const resourcesFilter = props.resources ? props.resources.filter((f) => !f.printer.laser) : []
    const [filter, setFilter] = useState(
        {
            description: "MVM",
            value: "",
            quantity: 1,
            printer: undefined
        });


    useEffect(() => {
        if (!isNullOrEmpty(props.user?.resource)) {
            onChangeResource(props.user?.resource);
        }
        // eslint-disable-next-line
    }, [props.user?.resource]);

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    const onChangeResource = (value) => {
        let resource = resourcesFilter.find((i) => i.resourceId === parseInt(value));
        if (resource) {
            filter.printer = resource.printer;
            setFilter({ ...filter });
        }
    }

    const sendLabel = () => {
        if (validateInputsRequired("formLabel")) {
            if (!filter.printer) {
                return showMessageToastCustom({ html: translate('select-resource', 'validations'), classes: 'red' });
            }
            if (navigator.userAgent !== 'logisticspwa' && filter.printer?.connectionType === ENUMS.ePrinterConnectionType.Bluetooth.value) {
                showMessageToastCustom(translate('general:warning'), translate('validations:service-not-available'), 3000, 'mdi mdi-alert-circle-outline red-text');
            } else {
                filter.quantity = filter.quantity === 0 ? 1 : filter.quantity
                props.sendLabel(filter, () => {
                    showMessageToastCustom(translate('general.info'), translate('print', 'general'), 2000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                    filter.value = ""
                    setFilter({ ...filter })
                })
            }
        }
    }

    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <Title icon="filter_frames" label={translate('identification-label', 'physical-confirmation')} />
                </div>
            </div>
            <div className="container-fluid" style={{ marginTop: '21px' }}>
                <div className="container">
                    <div className='card'>
                        <div className="card-content" style={{ padding: '10px', paddingBlockEnd: '10px' }}>
                            <div id="formLabel" className="row" style={{ marginBottom: '0px' }}>
                                <div className="input-field no-padding col s12">
                                    <Input
                                        type="text"
                                        maxLength="18"
                                        label={translate('description', 'general')}
                                        id="description"
                                        name='description'
                                        value={filter?.description}
                                        required
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s12">
                                    <Input
                                        required
                                        maxLength="18"
                                        id="value"
                                        name='value'
                                        label={translate('info', 'general')}
                                        type="text"
                                        value={filter?.value}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="input-field no-padding col s2" style={{ marginTop: '34px' }}>
                                    <Input
                                        required
                                        maxLength="2"
                                        step="1"
                                        max={50}
                                        id="quantity"
                                        name='quantity'
                                        label='Qtd.'
                                        type="number"
                                        value={filter?.quantity}
                                        onChange={(event) => {
                                            if (parseInt(event.target.value) > 50) {
                                                event.target.value = '50'
                                            }
                                            onChange(event)
                                        }}
                                    />
                                </div>
                                <div className="col s9 no-padding" >
                                    <Select
                                        required
                                        id="resource"
                                        name="resource"
                                        valuefield="resourceId"
                                        display="name"
                                        label={translate('resource', 'physical-confirmation')}
                                        placeHolder={translate('choose-one-option', 'general')}
                                        data={resourcesFilter}
                                        defaultValue={props.user?.resource}
                                        change={(event) => {
                                            onChangeResource(event.currentTarget.value)
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{ paddingTop: '5px' }}>
                        <Button
                            full="true"
                            text={translate('send', 'general')}
                            onClick={sendLabel}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        resources: state.logisticsResourceReducer.list,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        sendLabel: (filter, callback) => {
            dispatch(PhysicalConfirmationService.printLabelIdentification(filter, callback));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PrintLabelIdentification));


